module.exports = __webpack_public_path__ + "static/nectar-yellow-snowboards-0daaff2a420af8b279759cb496fc017c.jpg";